<template lang="pug">
.packages.px-5
  v-row(align="center")
    v-col
      h2.primary--text {{ $tc('Package._name', 2) }}
    v-col.justify-center
      h5.primaryHover--text {{$t('Shipment.totalVolume')}}:  {{ totalVolumeConverted | fixed }} cm³ / {{ (totalVolumeConverted * 0.000001) | fixed }} m³
    v-col.justify-center
      h5.primaryHover--text {{$t('Shipment.totalWeight')}}:  {{ totalWeightConverted | fixed }} kg. / {{ totalWeightConvertedLb | fixed }} lb.
    v-col.justify-center
      h5.primaryHover--text {{$t('Shipment.packageCounter')}}:  {{ packageCounter }}
    v-col.d-flex
      v-spacer
      g-btn.primary--text(@click="addPackage") {{$t('Shipment.addPackage')}}
  template(v-for="(pckg, i) in instance")
    template(v-if="isNotDeleted(pckg)")
      app-entity(
        :extra-data="extraData",
        :chips="false",
        @close="setAsDeleted($event, i)",
        @duplicate="duplicatePackage($event, i)",
        :path="`${path}[${i}]`",
        :parentPath="`${path}`",
        :entity="$findEntity(relation.type)",
        fromList,
        :key="key+ '' + i",
        :elementIndex="i",
        :visibleIndex="findVisibleIndex(pckg)",
        v-bind="{ ...$attrs, parent, selectorOnly, showInfo, relation, isActive, modalInstance, handlingUnits }",
      )
        template(v-for="(_, slot) in $slots")
          template(:slot="slot")
            slot(:name="slot")
      extra-field-groups(:path="`${path}[${i}]`", :disabled="pckg.status && pckg.status.blockEdit", v-bind="{ entity }")
</template>

<script>
import EntityMixin from '@/mixins';
import axios from 'axios';

export default {
  mixins: [EntityMixin],
  props: ['entity', 'chips', 'invert', 'relation', 'path', 'parent', 'extraData', 'parentInstance', 'selectorOnly', 'showInfo', 'isDraft', 'isActive'],
  data: () => ({
    key: 0,
    handlingUnits: [],
  }),
  filters: {
    fixed(val) {
      return Number.parseFloat(val).toFixed(2);
    },
  },
  methods: {
    async loadHandlingUnits() {
      try {
        const endpoint = this.$fetchLoad(`HandlingUnit?Where[]=h => h.Entity.Contains("Package") || h.Entity = null`, true)
        this.handlingUnits = (await axios.get(endpoint, { params: { pageSize: -1 }})).data.data;
      } catch (error) {
        console.log(this.$cleanString(error));
      }
    },
    addPackage() {
      if (this.instance === undefined)
        this.$store.commit('SET_INSTANCE_PATH', { path: this.path , value: [] });
      this.instance.push({ packageNo: this.$generateUid(), entityState: 4, _Entity: 'Package' });
    },
    isNotDeleted(element) {
      return !(_.get(element, 'entityState') === 2);
    },
    setAsDeleted (instance, i) {
      if (instance.id) {
        this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '['+i+'].entityState', value: 2 });
      } else {
        this.instance.splice(i, 1);
      }
      this.deletePackageContents(instance);
      this.key++;
    },
    duplicatePackage(pckg, index) {
      const newPckg = _.cloneDeep(pckg);
      delete newPckg.id;
      delete newPckg.uid;
      delete newPckg.externalId;
      newPckg.extraData = !newPckg.extraData ? [] : newPckg.extraData.map(({ extraFieldId, type, value }) => ({ entityState: 4, extraFieldId, new: true, type, value }));
      this.instance.splice(index + 1, 0, { ...newPckg, caseIdentifier: null, packageNo: this.$generateUid(), entityState: 4, _Entity: 'Package' });
      this.key++;
    },
    deletePackageContents({ packageNo }) {
      const newPackageContents = _.reduce(this.instancePackageContents, (acc, content) => {
        if (content.packageNo != packageNo) return [...acc, content];
        if (content.entityState != 4) {
          return [...acc, { ...content, entityState: 2 }];
        }

        return acc;
      }, [])
      this.$store.commit('SET_INSTANCE_PATH', { path: 'packageContents', value: newPackageContents });
    },
    findVisibleIndex(pckg) {
      if (!this.visiblePackages) return null;
      return this.visiblePackages.findIndex(vp => {
        if (pckg.id) return vp.id === pckg.id
        return vp.packageNo === pckg.packageNo
      });
    },
    libraToKilograms(v) {
      try{ return v/2.2046 } catch { return 0 };
    },
    kilogramsToLibra(v) {
      try{ return v*2.2046; } catch { return 0 };
    },
    centimetersToInches(v) {
      try{ return v*0.39370; } catch { return 0 };
    },
    inchesToCentimeters(v) {
      try{ return v/0.39370 } catch { return 0 };
    },
  },
  computed: {
    totalVolumeConverted() {
      return _.reduce(this.visiblePackages, (res, { packagingWidth, packagingHeight, packagingLength, dimensionUnit }) => {
        if (!packagingWidth || !packagingHeight || !packagingLength || !dimensionUnit) return res;
        const floatWidth = parseFloat(packagingWidth);
        const floatHeight = parseFloat(packagingHeight);
        const floatLength = parseFloat(packagingLength);
        const floatVolume = floatWidth * floatHeight * floatLength;
        const totalVolume = dimensionUnit === 'cm' ? floatVolume : floatVolume * 16.387;
        return res + totalVolume;
      }, 0.0);
    },
    totalWeightConverted() {
      return _.reduce(this.visiblePackages, (res, { packagingWeight, weightUnit }) => {
        if (!packagingWeight || !weightUnit) return res;
        const floatWeight = parseFloat(packagingWeight);
        const totalWeight = weightUnit === 'kg' ? floatWeight : this.libraToKilograms(floatWeight);
        return res + totalWeight;
      }, 0.0);
    },
    totalWeightConvertedLb() {
      return this.kilogramsToLibra(this.totalWeightConverted);
    },
    visiblePackages() {
      return (this.instance || []).filter(this.isNotDeleted);
    },
    packageCounter() {
      return this.visiblePackages.length;
    },
    instancePackageContents() {
      return _.get(this.parentInstance, 'packageContents', []);
    },
  },
  async created() {
    await this.loadHandlingUnits();
  },
}
</script>
